import { EuiLoadingSpinner } from '@equipmentshare/ds2'

import { Transaction, TransactionStatus } from '../../../../../../graphql'
import { STATUS_TO_HUMAN_READABLE } from '../../../../../../graphql/utils/status-to-human-readable'

import ProcessingStatus from '../ProcessingStatus'
import AwaitingApprovalStatus from '../AwaitingApprovalStatus'

export type StatusIndicatorProps = {
	transaction: Transaction,
}

export default function StatusIndicator( { transaction }: StatusIndicatorProps ) {
	const { transactionStatus: status, modifiedByUser } = transaction
	const friendlyName = status ? STATUS_TO_HUMAN_READABLE[ status ] : ''

	switch ( status ) {
		case TransactionStatus.Submitted:
			return (
				<AwaitingApprovalStatus
					label={friendlyName}
					transactionId={transaction.id}
				/>
			)
		case TransactionStatus.Cancelled:
			return (
				<span>
					{friendlyName} by {modifiedByUser.firstName} {modifiedByUser.lastName}
				</span>
			)
		case TransactionStatus.Processing:
			return (
				<ProcessingStatus
					label={friendlyName}
					transaction={transaction}
				/>
			)
		case TransactionStatus.Split:
			return (
				<EuiLoadingSpinner size="s" />
			)
		default:
			return <span>{friendlyName}</span>
	}
}
